import React from "react";
import { ProgramContainer } from "src/entities/formTemplateDataType";

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    callbackStepIndex: (stepIndex: number) => void;
}

export class LaborFooter extends React.Component<Props> {
 
  render() {
    const isOer = (this.props.programContainer.CategoryId || "").toLowerCase() === "oer";
        return (
            <>
                {this.props.isEng ? (
                    <footer className='ontario-footer ontario-footer--expanded'>
                        <div className='ontario-footer__expanded-top-section'>
                            <div className='ontario-row'>
                                <div className='ontario-columns ontario-small-12 ontario-medium-6'>
                                    <h2 className='ontario-h4'>Ministry of Labour, Immigration, Training and Skills Development</h2>
                                    <p>The Ministry of Labour, Immigration, Training and Skills Development advances safe, fair and harmonious workplace practices that are essential to the social and economic well-being of the people of Ontario.</p>
                                </div>
                                <div className='ontario-columns ontario-small-12 ontario-medium-6'>
                                    <h2 className='ontario-h4'>Contact us</h2>
                                    <a className='ontario-footer__button ontario-button ontario-margin-bottom-0-!' href='mailto: OccupationalExposureRegistry@ontario.ca'>Send us an email</a>
                                </div>
                            </div>
                        </div>
                        <div className='ontario-row ontario-footer__expanded-bottom-section'>
                            <div className='ontario-columns ontario-small-12'>
                               
                                 <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
                                    <li><a className='ontario-footer__link' {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/page/about-ontario'>About Ontario</a></li>
                                    <li><a className='ontario-footer__link' {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/page/accessibility'>Accessibility</a></li>
                                    <li><a className='ontario-footer__link' {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='http://news.ontario.ca/newsroom/en'>News</a></li>
                                    <li><a className='ontario-footer__link' {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/page/privacy-statement'>Privacy</a></li>
                                    <li>
                                        <a
                                            className='ontario-footer__link'
                                            href='#'
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.props.callbackStepIndex(4);
                                            }}
                                        >
                                            Terms of use
                                        </a>
                                    </li>
                                </ul>
                                <div className='ontario-footer__copyright'>
                                    <a className='ontario-footer__link' {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/page/copyright-information'> &copy; King's Printer for Ontario, <span className='ontario-nbsp'>2026</span></a>
                                </div>
                            </div>
                        </div>
                    </footer>
                ) : (
                    <footer className='ontario-footer ontario-footer--expanded'>
                        <div className='ontario-footer__expanded-top-section'>
                            <div className='ontario-row'>
                                <div className='ontario-columns ontario-small-12 ontario-medium-6'>
                                    <h2 className='ontario-h4'>Ministère du Travail, de l’Immigration, de la Formation et du Développement des compétences</h2>
                                    <p>Le ministère du Travail, de l'Immigration, de la Formation et du Développement des compétences promeut des pratiques de travail sûres, équitables et harmonieuses, essentielles au bien-être social et économique des habitants de l'Ontario.</p>
                                </div>
                                <div className='ontario-columns ontario-small-12 ontario-medium-6'>
                                    <h2 className='ontario-h4'>Communiquez avec nous</h2>
                                    <a className='ontario-footer__button ontario-button ontario-margin-bottom-0-!' href='mailto: OccupationalExposureRegistry@ontario.ca'>Envoyez-nous un courriel</a>
                                </div>
                            </div>
                        </div>
                        <div className='ontario-row ontario-footer__expanded-bottom-section'>
                            <div className='ontario-columns ontario-small-12'>
                                <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
                                    <li><a className='ontario-footer__link'  {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/fr/page/lontario-en-bref'>L'Ontario en bref</a></li>
                                    <li><a className='ontario-footer__link'  {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/fr/page/accessibilite'>Accessibilité</a></li>
                                    <li><a className='ontario-footer__link'  {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='http://news.ontario.ca/newsroom/fr'>Nouvelles</a></li>
                                    <li><a className='ontario-footer__link'  {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/fr/page/declaration-concernant-la-protection-de-la-vie-privee'>Confidentialité</a></li>
                                    <li>
                                        <a
                                            className='ontario-footer__link'
                                            href='#'
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.props.callbackStepIndex(4);
                                            }}
                                        >
                                            Conditions d’utilisation
                                        </a>
                                        </li>
                                </ul>
                                <div className='ontario-footer__copyright'>
                                    <a className='ontario-footer__link'  {...(isOer ? { target: "_blank", rel: "noopener noreferrer" } : {})} href='https://www.ontario.ca/fr/page/droits-dauteur'>&copy; Imprimeur du Roi pour l’Ontario, <span className='ontario-nbsp'>2023&ndash;25</span></a>
                                </div>
                            </div>
                        </div>
                    </footer>
                )}
            </>
        );
    }
}
